import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// * Components
import { Popup } from '../Popup';
import VkPlannedForm from './VkPlannedForm/VkPlannedForm';
import YoutubePlannedForm from './YoutubePlannedForm';
import { PopupTitle } from '../PopupTitle';
import PlatformForm from './PlatformForm';
import Platforms from './Platforms';
import { Button } from '../Button';
import PopupStructure from '../PopupStructure';
import { ButtonGroup } from '../ButtonGroup';
import RutubeForm from './RutubeForm';

// * Local
import { AddChannelPopupProps, SelectedPlatform } from './AddChannelPopup.interface';
import { useScreenWidth } from '../../hooks/useScreenWidth';

const dictionary: any = {
  "youtube": "Youtube",
  "rutube": "Rutube",
  "twitch": "Twitch",
  "trovo":  "Trovo",
  "gg": "GoodGame",
  "vk": "Вконтакте",
  "ok": "ОК",
  "telegram": "Telegram",
  "kick": "Kick",
  "boosty": "Boosty",
  "vk_video_live": "VkVideoLive",
  "other": "Другое"
};

const platformsWithPlannedEvents: SelectedPlatform["platform"][] = ["youtube", "vk"];

const AddChannelPopup: FC<AddChannelPopupProps> = (props) => {
  const { isMobile } = useScreenWidth();
  const [selectedPlatform, setSelectedPlatform] = useState<SelectedPlatform | null>(null);
  const navigate = useNavigate();

  const isPlatformWithPlannedEvents = selectedPlatform && platformsWithPlannedEvents.includes(selectedPlatform.platform);

  let headerComponent,
      contentComponent,
      footerComponent;

  const getPlatformComponent = (selectedPlatform: SelectedPlatform) => {
    if (selectedPlatform.platform === "youtube") {
      return <YoutubePlannedForm
        id="platform-form"
        selectedPlatform={selectedPlatform}
        closePopup={props.onClose}
      />;
    } else if (selectedPlatform.platform === "vk") {
      return <VkPlannedForm
        id="platform-form"
        selectedPlatform={selectedPlatform}
        closePopup={props.onClose}
      />;
    } else if (selectedPlatform.platform === "rutube") {
      return <RutubeForm
        id="platform-form"
        selectedPlatform={selectedPlatform}
        closePopup={props.onClose}
      />;
    } else {
      return <PlatformForm
        id="platform-form"
        selectedPlatform={selectedPlatform}
        clearSelectedPlatform={() => setSelectedPlatform(null)}
        closePopup={props.onClose}
      />;
    }
  };

  if (selectedPlatform) {
    headerComponent = (
      <PopupTitle
        clarity={isMobile && dictionary[selectedPlatform.platform]}
        onClose={props.onClose}
      >
        Добавить канал
      </PopupTitle>
    );

    contentComponent = getPlatformComponent(selectedPlatform);

    footerComponent = (
      <ButtonGroup>
        <Button kind="secondary" type="button" onClick={() => setSelectedPlatform(null)}>Назад</Button>

        <Button form='platform-form' kind="primary" type="submit">
          {isPlatformWithPlannedEvents ? "Добавить" : "Создать"}
        </Button>
      </ButtonGroup>
    );
  }
  else {
    headerComponent = isMobile && (
      <PopupTitle onClose={props.onClose}>
        Выберите платформу
      </PopupTitle>
    );

    contentComponent = (
      <Platforms setSelectedPlatform={setSelectedPlatform} />
    );

    footerComponent = (
      <Button
        kind="primary"
        onClick={() => {
          if (!props.user?.tariff.custom_links) {
            navigate('/tariffs');
          } else {
            setSelectedPlatform({ platform: 'other' });
          }
        }}
      >
        Другое
      </Button>
    );
  }

  return (
    <Popup {...props} maxWidth={selectedPlatform ? "530px" : "730px"}>
      <PopupStructure
        headerComponent={headerComponent}
        contentComponent={contentComponent}
        footerComponent={footerComponent}
      />
    </Popup>
  );
};

export default AddChannelPopup;
